import React from 'react'
import { Button,Typography,Paper, Dialog, DialogActions, DialogContent, DialogTitle, Input, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { update_products_in_stock_by_import } from "../../../../services/stock_service";

const StoreExistingStock = ({ open, handleClose, existingProducts ,handleClose_importProducts_to_stock_modal}) => {
    async function  handleAllClose(){
        handleClose();
        handleClose_importProducts_to_stock_modal();
    }
    let user=JSON.parse(localStorage.getItem('user-info'))
    const user_id=user.id;
    const user_role=user.role;

    async function submit_data() {
    const formData = new FormData();
    formData.append("performed_by", user_id);
   // formData.append("requester_role",user_role);
    formData.append("data", JSON.stringify(existingProducts));

    try {
        const response = await update_products_in_stock_by_import(formData);
        console.log("Produits modfiés avec succès:", response.data);
        handleAllClose();
        
       // handleClose_importProducts_to_stock_modal();


    } catch (error) {
        console.log("Erreur lors de l'ajout:", error.response);
    }

    }


    return (
        <Dialog open={open}  fullWidth maxWidth="md">
            <DialogTitle>Produits existants</DialogTitle>
            <DialogContent>
                <Typography variant="body1">
                    Certains produits existent déjà dans le stock. Voulez-vous les mettre à jour ?
                </Typography>
                <TableContainer component={Paper} style={{ marginTop: '20px' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Code produit</TableCell>
                                <TableCell>Nom</TableCell>
                                <TableCell>Quantité</TableCell>
                                <TableCell>Prix</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {existingProducts.map((product, index) => (
                                <TableRow key={index}>
                                    <TableCell>{product.product_code}</TableCell>
                                    <TableCell>{product.product_name}</TableCell>
                                    <TableCell>{product.product_quantity}</TableCell>
                                    <TableCell>{product.product_price}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
            <div className='dialogBottom'>
            <div>
                <Button onClick={handleAllClose} variant="contained" className="submit_but cancel_but">Annuler</Button>
                <Button onClick={submit_data} variant="contained" className="submit_but valide_but" >
                    Mettre à jour
                </Button>
                </div>
            </div>
            </DialogActions>
        </Dialog>
    );
};


export default StoreExistingStock 
